module.exports = __webpack_public_path__ + "static/1-21a7c7e2ac66a306a4829a88f0b55ad7.jpg";